export default __webpack_public_path__ + "static/media/game.37bff054.svg";